import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import MovieCreationOutlinedIcon from '@mui/icons-material/MovieCreationOutlined';
import styleColors from '../colors.styles';

const STRIPED_BACKGROUND = `repeating-linear-gradient(
  45deg,
  #eef1f4,
  #eef1f4 6px,
  #e3e7ec 6px,
  #e3e7ec 12px
)`;

const sizes = {
  list: {
    width: 134,
    height: 134,
    iconCircle: 56,
    iconSize: 28,
  },
  card: {
    width: 120,
    height: 120,
    iconCircle: 48,
    iconSize: 24,
  },
};

export default function EditableVideoThumbnail({ size, sx }) {
  const dimensions = sizes[size] || sizes.list;

  return (
    <Box
      aria-hidden
      sx={{
        alignItems: 'center',
        background: STRIPED_BACKGROUND,
        display: 'flex',
        flexShrink: 0,
        height: dimensions.height,
        justifyContent: 'center',
        width: dimensions.width,
        ...sx,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: styleColors.base.walmart_blue,
          borderRadius: '50%',
          display: 'flex',
          height: dimensions.iconCircle,
          justifyContent: 'center',
          width: dimensions.iconCircle,
        }}
      >
        <MovieCreationOutlinedIcon
          sx={{
            color: 'white',
            fontSize: dimensions.iconSize,
          }}
        />
      </Box>
    </Box>
  );
}

EditableVideoThumbnail.propTypes = {
  size: PropTypes.oneOf(['list', 'card']),
  sx: PropTypes.shape({}),
};

EditableVideoThumbnail.defaultProps = {
  size: 'list',
  sx: {},
};
